import React from "react";

import DashboardIcon from "@mui/icons-material/Dashboard";
import RequestsIcon from '@mui/icons-material/Email';
import OffersIcon from '@mui/icons-material/LocalOffer';
import HomesIcon from '@mui/icons-material/Home';
import CollectionsIcon from '@mui/icons-material/Collections';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import SettingsIcon from '@mui/icons-material/Settings';
import DateRangeIcon from '@mui/icons-material/DateRange';
import DescriptionIcon from '@mui/icons-material/Description';
import EuroIcon from '@mui/icons-material/Euro';

const allPages = [
    {
        title: 'Dashboard',
        enabled: true,
        href: 'dashboard',
        icon: <DashboardIcon/>
    },
    {
        title: 'Richieste',
        enabled: false,
        href: 'requests',
        icon: <RequestsIcon/>
    },
    {
        title: 'Filtri Richieste',
        enabled: true,
        href: 'filter_rules',
        icon: <PlaylistAddCheckIcon/>
    },
    {
        title: 'Offerte',
        enabled: true,
        href: 'offers',
        icon: <OffersIcon/>
    },
    {
        title: 'Prenotazioni',
        enabled: true,
        href: 'bookings',
        icon: <DateRangeIcon/>
    },
    {
        title: 'Tariffe',
        enabled: true,
        href: 'rates',
        icon: <EuroIcon/>
    },
    {
        title: 'Preventivi',
        enabled: true,
        href: 'quotes',
        icon: <DescriptionIcon/>
    },
    {
        title: 'Strutture',
        enabled: true,
        href: 'homes',
        icon: <HomesIcon/>
    },
    {
        title: 'Lepri',
        enabled: false,
        href: 'lepri',
        icon: <CollectionsIcon/>
    },
    {
        title: 'Impostazioni',
        enabled: true,
        href: 'settings',
        icon: <SettingsIcon/>
    }
];

const pages = allPages.filter(p => p.enabled);

export {pages}